import {createAction} from 'redux-actions';
import GreenLeafApi from '../GreenLeafApi';

const getCompanies = createAction('GET_COMPANIES', query => query, () => ({ async: true, httpMethod: GreenLeafApi.Company.get }));
const getPrograms = createAction('GET_PROGRAMS', query => query, () => ({ async: true, httpMethod: GreenLeafApi.Program.get }));
const getTeams = createAction('GET_TEAMS', query => query, () => ({ async: true, httpMethod: GreenLeafApi.Team.get }));
const getContacts = createAction('GET_CONTACTS', query => query, () => ({ async: true, httpMethod: GreenLeafApi.Contact.get }));

const deleteTeam = createAction('DELETE_TEAM', id => id, () => ({ async: true, httpMethod: GreenLeafApi.Team.delete }));

const logout = createAction('LOGOUT');
const clearErrors = createAction('CLEAR_ERRORS');

export { getCompanies, getPrograms, getTeams, logout, getContacts, deleteTeam, clearErrors };


// WEBPACK FOOTER //
// ./src/components/utils/actions/index.js